<div class="main-container row m-0 p-0">
  <div class="profile-container col-12" style="position: relative">
    <div class="profile-avatar">
      <div>
        {{ user.first_name.charAt(0) + " " + user.last_name.charAt(0) }}
      </div>
    </div>
    <div class="company-profile">
      <!-- <h1 class="text-xl font-bold text-buupass-pink">User Profile</h1> -->
      <!-- Company Information Section -->
      <div class="company-info">
        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <div class="d-flex flex-row align-items-center profile-entry">
              <img src="./assets/Menu sections/icons/person_icon.svg" alt="" />
              <p style="padding-left: 20px">
                {{ user.first_name + " " + user.last_name }}
              </p>
            </div>
            <div class="d-flex flex-row align-items-center profile-entry">
              <img src="./assets/Menu sections/icons/envelope_icon.svg" alt="" style="color: orange" />
              <p style="padding-left: 20px">{{ user.email }}</p>
            </div>
            <div class="d-flex flex-row align-items-center profile-entry">
              <img src="./assets/Menu sections/icons/building_icon.svg" alt="" />
              <p style="padding-left: 20px">{{ user.company_name }}</p>
            </div>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>

      <!-- Approval Settings Tab -->
      <div class="approval-settings pt-2 pb-4 row">
        <div class="col-md-12">
          <ng-container *ngIf="isFetchingApprovalStages">
            <div class="loader"></div>
          </ng-container>
          <div *ngIf="!isFetchingApprovalStages" class="bg-gray-100 p-4 rounded-lg w-full">
            <div class="row g-4">
              <div class="col-md-6">
                <div class="profile-info-container">
                  <div class="input-col">
                    <label for="">Phone Number *</label>
                    <input type="text" value="{{ userProfile.phone_number }}" [placeholder]="user.phone_number"
                      disabled />
                  </div>
                  <div class="p-2 pt-4 bg-gray-100 edit-icon" (click)="openUpdateModal('phone')">
                    <img src="assets/images/icons_new/options.svg" alt="Edit" class="options-icon me-2" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="profile-info-container">
                  <div class="input-col">
                    <label for="">ID/Passport *</label>
                    <input type="text" value="{{ userProfile.id_or_passport }}" placeholder="{{ user.id_or_passport }}"
                      disabled />
                  </div>
                  <div class="p-2 pt-4 bg-gray-100 edit-icon" (click)="openUpdateModal('idPassport')">
                    <img src="assets/images/icons_new/options.svg" alt="Edit" class="options-icon me-2" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="profile-info-container">
                  <div class="input-col">
                    <label for="">Date of birth *</label>
                    <input type="text" value="{{ userProfile.date_of_birth }}" placeholder="{{ user.date_of_birth }}"
                      disabled />
                  </div>
                  <div class="p-2 pt-4 bg-gray-100 edit-icon" (click)="openUpdateModal('dateOfBirth')">
                    <img src="assets/images/icons_new/options.svg" alt="Edit" class="options-icon me-2" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="profile-info-container">
                  <div class="input-col">
                    <label for="">Salutation *</label>
                    <input type="text" value="{{ userProfile.salutation }}" placeholder="{{ user.salutation }}"
                      disabled />
                  </div>
                  <div class="p-2 pt-4 bg-gray-100 edit-icon" (click)="openUpdateModal('salutation')">
                    <img src="assets/images/icons_new/options.svg" alt="Edit" class="options-icon me-2" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="profile-info-container">
                  <div class="input-col">
                    <label for="">Gender *</label>
                    <input type="text" value="{{ userProfile.gender }}" placeholder="{{ user.gender }}" disabled />
                  </div>
                  <div class="p-2 pt-4 bg-gray-100 edit-icon" (click)="openUpdateModal('gender')">
                    <img src="assets/images/icons_new/options.svg" alt="Edit" class="options-icon me-2" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="profile-info-container">
                  <div class="input-col">
                    <label for="">Nationality *</label>
                    <input type="text" value="{{ userProfile.nationality }}" placeholder="{{ user.nationality }}"
                      disabled />
                  </div>
                  <div class="p-2 pt-4 bg-gray-100 edit-icon" (click)="openUpdateModal('nationality')">
                    <img src="assets/images/icons_new/options.svg" alt="Edit" class="options-icon me-2" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="profile-info-container">
                  <div class="input-col">
                    <label for="">Preferred Currency *</label>
                    <input type="text" value="{{ userProfile.preferred_currency || 'KES' }}"
                      placeholder="KES" disabled />
                  </div>
                  <div class="p-2 pt-4 bg-gray-100 edit-icon" (click)="openUpdateModal('currency')">
                    <img src="assets/images/icons_new/options.svg" alt="Edit" class="options-icon me-2" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="lower-profile d-flex flex-column items-start justify-content-between w-100">
                  <span>Designation</span>
                  <span>{{ "- - - " }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="lower-profile d-flex flex-column items-start justify-content-between w-100">
                  <span>Reporting Manager</span>
                  <span>{{ "- - - " }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="p-2">
          <div class="flex justify-end mt-2">
            <button
              class="btn btn-secondary text-white rounded-md"
              (click)="openUpdateModal()"
            >
              Update
            </button>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <!-- Edit user Modal -->
  <div #editModal class="modal">
    <div class="modal-content">
      <h2 class="mt-3 text-center">Edit User</h2>
      <form [formGroup]="userForm">
        <div class="form-col">
          <!-- Phone Number -->
          <div class="form-group col-md-6" *ngIf="isPhoneField">
            <label for="phone_number">Phone Number</label>
            <input type="text" id="phone_number" class="form-control" formControlName="phone_number"
              placeholder="Enter Phone Number" maxlength="30" />
          </div>
          <!-- ID or Passport -->
          <div class="form-group col-md-6" *ngIf="isPassField">
            <label for="id_or_passport">ID or Passport</label>
            <input type="text" id="id_or_passport" class="form-control" formControlName="id_or_passport"
              placeholder="Enter ID or Passport" maxlength="50" />
          </div>
          <!-- Date of birth -->
          <div class="form-group col-md-12 text-center" *ngIf="isDobField">
            <mat-form-field appearance="fill" class="w-100 text-center">
              <mat-label>Date of birth *</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="date_of_birth" placeholder="Choose a date"
                required />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <!-- salutation -->
          <div class="form-group col-md-12" *ngIf="isSalutationField">
            <label for="salutation">Salutation *</label>
            <select id="salutation" class="form-control" formControlName="salutation" required>
              <option value="" disabled selected>-- Select Salutation --</option>
              <option *ngFor="let salutation of salutations" [value]="salutation">
                {{ salutation }}
              </option>
            </select>
            <div *ngIf="
                userForm.get('salutation')?.invalid &&
                userForm.get('salutation')?.touched
              " class="error">
              Salutation is required.
            </div>
          </div>
          <!-- Gender -->
          <div class="form-group col-md-12" *ngIf="isGenderField">
            <label for="gender">Gender *</label>
            <select id="gender" class="form-control" formControlName="gender" required>
              <option value="" disabled selected>-- Select gender --</option>
              <option *ngFor="let gender of genders" [value]="gender">
                {{ gender }}
              </option>
            </select>
            <div *ngIf="
                userForm.get('gender')?.invalid &&
                userForm.get('gender')?.touched
              " class="error">
              Gender is required.
            </div>
          </div>
          <div class="form-group col-md-12" *ngIf="isNationalityField">
            <label for="nationality">Nationality *</label>
            <select id="nationality" class="form-control" formControlName="nationality" required>
              <option value="" disabled selected>-- Select Nationality --</option>
              <option *ngFor="let nationality of nationalities" [value]="nationality.code">
                {{ nationality.name }}
              </option>
            </select>
            <div *ngIf="
                userForm.get('nationality')?.invalid &&
                userForm.get('nationality')?.touched
              " class="error">
              Nationality is required.
            </div>
          </div>
          <!-- Preferred Currency -->
          <div class="form-group col-md-12" *ngIf="isCurrencyField">
            <label for="preferred_currency">Preferred Currency *</label>
            <select id="preferred_currency" class="form-control" formControlName="preferred_currency" required>
              <option value="" disabled selected>-- Select Currency --</option>
              <option *ngFor="let currency of currencies" [value]="currency">
                {{ currency }}
              </option>
            </select>
            <small class="text-muted">Amounts are shown in this currency. Payments are still settled in KES.</small>
            <div *ngIf="
                userForm.get('preferred_currency')?.invalid &&
                userForm.get('preferred_currency')?.touched
              " class="error">
              Currency is required.
            </div>
          </div>
          <div class="text-center" *ngIf="errorMessage">
            <h6 class="text-danger">
              {{ errorMessage }}
            </h6>
          </div>
          <div class="modal-buttons-top d-flex justify-content-center">
            <button type="button" class="btn btn-secondary mx-2" (click)="closeUpdateModal()">
              Cancel
            </button>
            <button type="button" class="btn newuser mx-2" (click)="onSubmit()">
              <ng-container *ngIf="isUpdatingUser">
                <div class="loader"></div>
              </ng-container>
              <ng-container *ngIf="!isUpdatingUser">
                Update
              </ng-container>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- Department Modal -->

  <!-- Group Modal -->

  <!-- Delete Department Confirmation Modal -->

  <!-- Delete Confirmation Modal for Groups -->

  <!-- Add Stage Modal -->

  <!-- Edit Stage Modal -->

  <!-- Delete Confirmation Modal -->
</div>